import React, { useEffect } from "react";
import PropTypes from "prop-types";
import createJWT from "Components/ChatSnippets/Zendesk/Jwt/authorization";

const ZendeskJWTComponent = ({ authData }) => {
  const {
    partnerNameOriginal,
    partnerSurnameOriginal,
    displayName,
    email,
    userName,
    id,
  } = authData;

  const fullName =
    partnerNameOriginal && partnerSurnameOriginal
      ? `${partnerNameOriginal} ${partnerSurnameOriginal}`
      : displayName;
  const userEmail = email || userName;
  const expirationTime = Math.floor(Date.now() / 1000) + 60;

  const userInfo = {
    name: fullName,
    email: userEmail,
    external_id: `ze-id-${id}`,
    email_verified: true,
    exp: expirationTime,
    scope: "user",
  };

  useEffect(() => {
    const handleLogin = async () => {
      try {
        const jwtToken = await createJWT(userInfo);
        if (!localStorage.getItem("jwtLoggedIn")) {
          window.zE("messenger", "loginUser", (callback) => {
            callback(jwtToken);
            localStorage.setItem("jwtLoggedIn", "true");
          });
        }
      } catch (error) {
        console.error("JWT login error:", error);
      }
    };

    const handleZendeskReady = () => {
      handleLogin();
    };

    if (authData) {
      if (window.zE) {
        handleLogin();
      } else {
        // Wait for Zendesk to be loaded
        window.addEventListener("ZendeskLoaded", handleZendeskReady);
      }
    }

    return () => {
      window.removeEventListener("ZendeskLoaded", handleZendeskReady);
    };
  }, [authData]);

  return null;
};

ZendeskJWTComponent.propTypes = {
  authData: PropTypes.shape({
    partnerNameOriginal: PropTypes.string.isRequired,
    partnerSurnameOriginal: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};

export default React.memo(ZendeskJWTComponent);
